import { getUser } from "@utils/api-communication/RestApiCli";
import { UserOnboarding } from "types/userTypes";
import { parseUserOnboarding } from "./onboardingUtils";

export const ONBOARDING_LOOKUP_TIMEOUT_MS = 5000;

export const fetchUserOnboarding = (timeoutMs?: number): Promise<UserOnboarding | null> =>
  new Promise((resolve, reject) => {
    let settled = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const settle = (finish: () => void) => {
      if (settled) return;
      settled = true;
      if (timer !== undefined) clearTimeout(timer);
      finish();
    };
    if (timeoutMs !== undefined) {
      timer = setTimeout(
        () => settle(() => reject(new Error("Onboarding lookup timed out"))),
        timeoutMs,
      );
    }
    getUser(
      {},
      (response) => settle(() => resolve(parseUserOnboarding(response?.data?.onboarding))),
      (error) => settle(() => reject(error ?? new Error("Onboarding lookup failed"))),
    );
  });
